import types from './types';

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET:
      return {
        ...state,
        ...action.config,
      };

    default:
      return state;
  }
};

export default reducer;
